// bundle related reducers
import { combineReducers } from "redux";
import { reducer as groupPermissions } from "./GroupDetails";

export default combineReducers({
  groupPermissions,
});
